module.exports = __webpack_public_path__ + "static/media/egyptCover.2a8ab74a.png";